import { NgModule } from '@angular/core';
import { GtmGgCheckoutPageEventBuilder } from './gtm-gg-checkout-page-event.builder';

@NgModule({})
export class GtmGgCheckoutPageEventModule {
  constructor(_gtmGgCheckoutPageEventBuilder: GtmGgCheckoutPageEventBuilder) {}
}
